export const titleClasses = {
  small: 'text-lg lg:text-3xl',
  default: 'text-xl lg:text-4xl',
  large: 'text-2xl lg:text-4xl'
}
